import { useTranslation } from "react-i18next";
import { useState, useMemo } from "react";
import type { FAQ as FAQType } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import FAQForm from "./FAQForm";
import FAQReorder from "./FAQReorder";

function SidebarFAQForm({ ...props }: any) {
  return <CrudEdit collectionName="faqs" Form={FAQForm} {...props} />;
}

function FAQ() {
  const { t } = useTranslation();
  const [isReordering, setIsReordering] = useState(false);

  const columns: TableColumn<FAQType>[] = useMemo(
    () => [
      {
        field: "order",
        header: "#",
        style: { width: "60px" },
      },
      {
        field: "question",
        header: t("faqs.question"),
        sortable: true,
        renderType: "bold",
      },
      {
        field: "answer",
        header: t("faqs.answer"),
      },
    ],
    [t]
  );

  const actions: CrudHeaderAction[] = useMemo(
    () => [
      {
        title: t("faqs.reorder"),
        icon: "AdjustmentsHorizontalIcon",
        action: () => setIsReordering(true),
        type: "white",
      },
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ],
    [t]
  );

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "question$containsi",
        label: t("faqs.question"),
        renderType: "input",
        icon: "MagnifyingGlassIcon",
      },
    ];
  }, [t]);

  if (isReordering) {
    return (
      <div className="pt-2 px-4">
        <FAQReorder onClose={() => setIsReordering(false)} />
      </div>
    );
  }

  return (
    <CrudList
      collectionName="faqs"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="order:ASC"
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarFAQForm}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default FAQ;
